import { createLucideIcon } from 'lucide-react';
export const KeySolidIcon = createLucideIcon('key-solid-icon', [
  [
    'path',
    {
      d: 'M3.1181 20.8836V16.4423L9.03988 10.027C9.03988 10.027 9.21419 7.44482 10.0268 6.07914C11.3959 3.77836 13.9747 2.62478 16.9356 3.61174C19.1303 4.3433 21.5648 6.62021 20.8834 10.027C20.4886 12.0009 19.4281 13.5561 17.4291 14.4683C15.3179 15.4317 12.0008 13.9748 12.0008 13.9748H11.0138V16.4423H9.53336V18.4162H7.06595V20.8836H3.1181Z',
      key: '1m50na',
    },
  ],
  [
    'circle',
    {
      cx: '15.9999',
      cy: '8',
      r: '1',
      fill: 'var(--contrast)',
      key: 'lgodtb',
    },
  ],
]);
